import { UserDetailsResponse, UserExportKind } from '@fullstory/client-api';
import { Box, RestrictedButton } from '@fullstory/components';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getExportUserUrl } from './utils';

type UserOverlayExportsProps = { userDetails: UserDetailsResponse; disabled: boolean };
export const UserOverlayExports: FC<UserOverlayExportsProps> = ({ userDetails, disabled }) => (
  <>
    <Box paddingBottom={8}>
      <RestrictedButton
        variant="outline"
        fullWidth
        justifyContent="center"
        disabled={disabled}
        tooltip="Only Admins and Architects may perform user exports"
        href={getExportUserUrl(
          userDetails.UserAppId,
          userDetails.UserId,
          UserExportKind.ExportUserEvents,
        )}
      >
        <FormattedMessage defaultMessage="Download user events" id="C+109G" />
      </RestrictedButton>
    </Box>
    <Box paddingBottom={8}>
      <RestrictedButton
        variant="outline"
        fullWidth
        justifyContent="center"
        disabled={disabled}
        tooltip="Only Admins and Architects may perform user exports"
        href={getExportUserUrl(
          userDetails.UserAppId,
          userDetails.UserId,
          UserExportKind.ExportUserPages,
        )}
      >
        <FormattedMessage defaultMessage="Download user pages" id="kafcp+" />
      </RestrictedButton>
    </Box>
  </>
);
